//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'
import footerNav from '@/components/footerNav'
import bottom from '@/assets/img/bottom.png'

export default {
  name: "reportRowAdd",
  components: {
    footerNav
  },
  computed: {
  },
  data() {
    return {
      bottom,
      number:'',
      checkAll:false,
      type:1,
      result:[],
      show:false,
      value:'',
      list:[
        {code:'DJJWQ-AM211072-AASDEA',color:'粉色',size:'165',number:'',choose:false,index:1},
        {code:'DJJWQ-AM211072-AASDEA',color:'粉色',size:'165',number:'',choose:false,index:2},
        {code:'DJJWQ-AM211072-AASDEA',color:'粉色',size:'165',number:'',choose:false,index:3},
        {code:'DJJWQ-AM211072-AASDEA',color:'粉色',size:'165',number:'',choose:false,index:4},
        ]
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onConfirm(value) {
      this.color = value;
      this.showPicker = false;
    },
    toEdit(){
      this.$router.push({name:'productCertificateEdit'})
    },
    next(){
      var arr = [];
      this.list.forEach(e => {
        if (e.choose) {
          arr.push(e)
        }
      });
      this.$router.push({name: 'reportAdd', params: {arr:arr}})
    },
    chooseAll(){
      let a = this.checkAll;
      this.list = this.list.map(e => {
        e.choose = a;
        return e;
      });
    },
    // checkboxChange(i,$event){
    //   this.type=1;
    //   this.selectRow = i
    //   if($event){
    //     this.show = true;
    //   }
    // },
    choose() {
      let a = true;
      this.list.forEach(e => {
        if (e.choose === false) {
          a = false;
        }
      });
      console.log(a)
      this.checkAll = a;
    },

    onSearch(){

    },
    chooseConfirm(){

    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/report/rowAdd.vue